import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../state/app.state';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FetchProjectDocumentsRequest } from '../../../../../../core/projects.actions';
import { projectDocuments } from '../../../../../../core/projects.selectors';
import { Ability, subject } from '@casl/ability';

@Component({
    selector: 'app-documents-wrapper',
    templateUrl: './documents-wrapper.component.html',
    styleUrls: ['./documents-wrapper.component.scss'],
    standalone: false
})
export class DocumentsWrapperComponent implements OnInit, OnDestroy {
  tableData: any;
  projectId: string;
  canEdit = false;

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private route: ActivatedRoute,
    private ability: Ability,
  ) {
    this.projectId = this.route.snapshot.paramMap.get('projectId');
    this.canEdit = this.ability.can('create', subject('Document', { project_id: this.projectId }));

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp.tab === 'documents') {
          this.fetchDocuments();
        }
      });
  }

  ngOnInit(): void {
    this.store.select(projectDocuments)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(documents => {
        if (documents) {
          this.tableData = documents;
        }
      });

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp.tab === 'documents') {
          this.fetchDocuments();
        }
      });

  }

  fetchDocuments(): void {
    if (!this.projectId) {
      return;
    }

    this.store.dispatch(FetchProjectDocumentsRequest({
      payload: { projectId: this.projectId },
    }));
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
